import React, { useEffect, useState } from "react";
import { Dropdown } from "../components/Dropdown";
import { ShortAnswer } from "../components/ShortAnswer";
import { SubmitButton } from "../components/SubmitButton";
import { liff } from "@line/liff";
import "./style.css";
import RootLayout from "layouts/RootLayout";
import { Dialog, DialogTitle } from "@mui/material";


const LIFF_ID = process.env.REACT_APP_PROFILE_LIFF_ID;
const FETCH_SUCCESS = 200;

//eucare jake.chen
// const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbzQRGTNUqI8QBkYt-5C5smS5czCK8OMY7iAJwSfSmMHQjeQQdA-NNLG7J_2EEKHcjIt/exec'
// const deleteProfileUrl = 'https://script.google.com/macros/s/AKfycbyrix66wi0pge2ZC_zi_KLnj7ngu2pEjNjFb5oBJpJ30X_EDsRtn6zu_Nq5OYh1Odo_Iw/exec'

// twdata puppy
const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbwJ1cL-QqTZNLvD2H36QRrf2dMeWUH4gtMTOuiIm3o26NUf3hXvNG3CbS7g-e4vIbpE7g/exec'
const deleteProfileUrl = 'https://script.google.com/macros/s/AKfycbyGg5j-_eJVnTA2gd5EmZVaOs-bT3OQFCASTzGHVvFlzCZkdDP3_BJuTnFRNeSJzQqLWg/exec'



const initializeLIFF = async () => {
    try {
        await liff.init({ liffId: LIFF_ID });

        if (!liff.isLoggedIn()) {
            liff.login();
        }
        if (!liff.isInClient()) {
            alert('基本資料請使用手機 LINE APP 開啟填寫，如您有緊急需求請撥打 119 或可參考下列就醫資訊詢問');
            window.location.href = "https://klchb.gocare.tw/clinicList";   // dev
            return null;
        }
        return liff;
    } catch (error: unknown) {
        console.error('初始化 liff 時出錯：', error);
    }
};


const Profile = (): JSX.Element => {
    const [liffClientObject, setLiffClientObject] = useState(null);
    // name of the user
    const [name, setName] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [kidscount, setKidscount] = useState(0);
    const [kidData, setKidData] = useState([{ name: '', age: '', weight: '', primary_medical: '' }]);
    const [deleteBtn, setDeleteBtn] = useState(false);


    const userId = liffClientObject?.getContext()?.userId
    const accessToken = liffClientObject?.getAccessToken()



    useEffect(() => {
        const initialize = async () => {
            const liffObject = await initializeLIFF();
            setLiffClientObject(liffObject);
        };
        initialize()
    }, []);


    useEffect(() => {

        if (userId === undefined) return
        if (accessToken === undefined) return

        const getProfileUrl = `https://script.google.com/macros/s/AKfycbwJ1cL-QqTZNLvD2H36QRrf2dMeWUH4gtMTOuiIm3o26NUf3hXvNG3CbS7g-e4vIbpE7g/exec?userId=${userId}&accessToken=${accessToken}`;

        fetch(getProfileUrl)
            .then(response => response.json())
            .then(data => {
                if (data.status_code === FETCH_SUCCESS) {
                    setDeleteBtn(true);
                    setName(data.data.name);
                    setPhone(data.data.phone);
                    setAddress(data.data.address);
                    setKidscount(data.data.child_number);
                    setKidData(data.data.childes);
                } else {
                    setKidscount(1);
                }
                setLoading(false);
                console.log(data);
            });

    }, [userId, accessToken])


    const formRef = React.useRef<HTMLFormElement>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        if (validate()) {
            if (liff) {
                console.log(await liff.getProfile());
                await fetch(updateProfileUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'text/plain;charset=utf-8',
                    },
                    body: JSON.stringify({
                        accessToken: accessToken,
                        profile: await liff.getProfile(),
                        userId: userId,
                        name: name,
                        phone: phone,
                        address: address,
                        child_number: kidscount,
                        childes: kidData,
                    })
                }).then(async () => {
                    await liff.sendMessages([{
                        type: 'text',
                        text: '基本資料已儲存'
                    }]);
                }).catch((error) => {
                    // 顯示錯誤訊息提示，跳出訊息內容：因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119
                    alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!');
                });
                liff.closeWindow();
            } else {
                console.error('LIFF client object is not initialized');
                alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!');
            }
        }
    };

    const handleDelete = async () => {
        const delConfirm = window.confirm('確定刪除資料嗎')

        if (!delConfirm) {
            alert('刪除取消')
            return;
        }
        setLoading(true);

        if (validate()) {
            if (liff) {
                await fetch(deleteProfileUrl, {
                    method: 'POST',
                    body: JSON.stringify({
                        accessToken: accessToken,
                        userId: userId,
                    })
                }).then(async () => {
                    await liff.sendMessages([{
                        type: 'text',
                        text: '基本資料已刪除'
                    }]);
                }).catch((error) => {
                    console.log(error);
                    // 顯示錯誤訊息提示，跳出訊息內容：因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119
                    alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!');
                });
                setLoading(false);
                liff.closeWindow();
            } else {
                console.error('LIFF client object is not initialized');
                alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!');
            }
        }
    };

    const validate = () => {
        const form = formRef.current;
        if (form?.checkValidity()) {
            return true;
        } else {
            return false;
        }
    };

    const handleKidsNum = (e) => {
        const kidsNum = Number(e.target.value)
        setKidscount(kidsNum);

        const newKidsData = Array.from({ length: kidsNum }, () => ({
            name: '', age: '', weight: '', primary_medical: ''
        }));
        setKidData(newKidsData);
    }

    const handleKidsInput = (e, index, type) => {
        const temp = [...kidData];
        temp[index][type] = e.target.value;
        setKidData(temp);
    }



    return (
        <RootLayout title="基本資料">
            <form onSubmit={handleSubmit} ref={formRef} >
                <div style={{ display: 'flex', flexDirection: 'column', padding: '20px 44px', gap: '16px' }}>
                    <ShortAnswer className="" hasDiv={false} text="姓　　名："
                        dataInput={name}
                        disabled={loading}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                    />

                    <ShortAnswer className="" hasDiv={false} text="聯絡電話："
                        dataInput={phone}
                        disabled={loading}
                        onChange={(e) => {
                            setPhone(e.target.value);
                        }}
                    />

                    <ShortAnswer className="" hasDiv={false} text="地　　址："
                        dataInput={address}
                        disabled={loading}
                        onChange={(e) => {
                            setAddress(e.target.value);
                        }}
                    />

                    <Dropdown
                        className=""
                        frame="/img/frame.svg"
                        frameClassName="dropdown-2"
                        hasDiv={false}
                        options={["1", "2", "3", "4", "5", "6", "7", "8"]}
                        dataSelected={String(kidscount)}
                        disabled={loading}
                        onChange={handleKidsNum}
                        text="家中孩子數量："
                    />

                    {Array.from({ length: kidscount }, (_, index) => (
                        <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <h3
                                style={{
                                    color: '#555555',
                                    fontSize: '20px',
                                    fontWeight: 700,
                                }}
                            >
                                孩子 {index + 1}
                            </h3>
                            <ShortAnswer
                                className=""
                                hasDiv={false}
                                text='孩子姓名：'
                                dataInput={kidData[index].name}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'name')}
                            />
                            <ShortAnswer
                                className=""
                                hasDiv={false}
                                text="年　　齡："
                                dataInput={kidData[index].age}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'age')}
                            />
                            <ShortAnswer
                                className=""
                                hasDiv={false}
                                text="體　　重："
                                dataInput={kidData[index].weight}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'weight')}
                            />
                            <ShortAnswer
                                className=""
                                hasDiv={false}
                                text="平時主要就醫診所機構："
                                dataInput={kidData[index].primary_medical}
                                disabled={loading}
                                onChange={(e) => handleKidsInput(e, index, 'primary_medical')}
                            />
                        </div>
                    ))}
                    <SubmitButton className="profileSubmitbtn" text="寫好送出" loading={loading}
                        disabled={loading}
                    />
                    {deleteBtn && <SubmitButton type="button" className="profileDeletebtn" onClick={handleDelete} text="刪除基本資料" />}
                </div>
            </form>

            <Dialog open={loading}>
                <DialogTitle >
                    資料存取中...
                </DialogTitle>
            </Dialog>
        </RootLayout>
    );
};

export default Profile;